import React from 'react';
import { detectMobile } from '../../../utils/UiHelper';
import {
    SkeletonContainer,
    SkeletonList,
    SkeletonCard,
    SkeletonCardTop,
    SkeletonCardTopDate,
    SkeletonCardTopDescr,
    SkeletonCardItem,
    SkeletonLine,
    SkeletonButtonsWrapper,
    SkeletonButton,
} from '../styled';
import { SkeletonAnimation } from '../skeletonAnimation';

const HighlightsSkeleton = () => {
    const isMobile = detectMobile();
    const itemCount = isMobile ? 5 : 8;
    const buttonCount = 3;

    const renderSkeletonCard = () =>
        Array.from({ length: itemCount }, (_, index) => (
            <SkeletonCard key={`highlights_${index}`} width={'280px'}>
                <SkeletonCardTop key={`highlights_${index}_top`}>
                    <SkeletonCardTopDescr key={`highlights_${index}_descr`}>
                        <SkeletonCardItem width={'auto'}>
                            <SkeletonLine
                                height={'8px'}
                                width={'104px'}
                                margin={'6px 0 22px'}
                            />
                        </SkeletonCardItem>

                        <SkeletonCardItem width={'auto'}>
                            <SkeletonLine
                                height={'10px'}
                                width={'127px'}
                                margin={'0 0 8px'}
                            />
                        </SkeletonCardItem>

                        <SkeletonCardItem width={'auto'}>
                            <SkeletonLine
                                height={'10px'}
                                width={'75px'}
                                margin={'0 0 14px'}
                            />
                        </SkeletonCardItem>
                    </SkeletonCardTopDescr>
                    <SkeletonCardTopDate key={`highlights_${index}_date`}>
                        <SkeletonCardItem width={'auto'}>
                            <SkeletonLine
                                height={'8px'}
                                width={'51px'}
                                margin={'6px 0 13px'}
                            />
                        </SkeletonCardItem>
                        <SkeletonCardItem width={'auto'}>
                            <SkeletonLine height={'10px'} width={'40px'} />
                        </SkeletonCardItem>
                    </SkeletonCardTopDate>
                </SkeletonCardTop>
                <SkeletonButtonsWrapper>
                    {Array.from({ length: buttonCount }, (_, btnIndex) => (
                        <SkeletonButton
                            key={`highlights_btn_${btnIndex}`}
                            width={'63px'}
                            margin={'0'}
                        />
                    ))}
                </SkeletonButtonsWrapper>
            </SkeletonCard>
        ));

    return (
        <SkeletonContainer
            margin={isMobile ? '0 0 8px' : '0 0 24px'}
            isMobile={isMobile}
        >
            <SkeletonList gap={'16px'}>{renderSkeletonCard()}</SkeletonList>
            <SkeletonAnimation />
        </SkeletonContainer>
    );
};

export default HighlightsSkeleton;
